import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutRating: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
  >
    <path
      fill={colors['--green-500']}
      d="M54.867 26.877H42.695l4.173 4.172-4.173 4.348-6.955-6.956-10.606 10.433 3.825 3.825 6.781-6.955 6.955 6.955 7.999-7.824 4.173 4.173V26.876z"
    />
    <path
      fill={colors['--green-500']}
      d="M19.695 52.779h40.62a2.898 2.898 0 002.898-2.9V20.867A3.866 3.866 0 0059.347 17H20.662a3.866 3.866 0 00-3.866 3.866v29.016a2.904 2.904 0 002.9 2.9v-.003zm1.942-30.935h36.732v26.094H21.637V21.844zm43.398 32.713H14.967a.969.969 0 00-.967.967v3.582a3.984 3.984 0 004.36 3.467l-.017.002h43.314a3.978 3.978 0 004.341-3.448l.002-.019v-3.582a.969.969 0 00-.967-.967l.002-.002zm-18.99 4.977H33.92a.969.969 0 010-1.938h.04-.002 12.12a.969.969 0 010 1.938h-.04.008z"
    />
    <path stroke={colors['--green-500']} strokeWidth="3" d="M1.5 1.5H78.5V78.5H1.5z" />
  </svg>
);

export default AboutRating;
